import { TextField } from "@fluentui/react";
import React, { FC, Fragment, useState } from "react";
import moment from "moment";
import { TruckNomination } from "../../models";
import EtaModal from "./EtaModal";

type Props = {
  nomination: TruckNomination;
  onSuccess(value: string): void;
};

const EtaButton: FC<Props> = (props: Props) => {
  const [showModal, setShowModal] = useState(false);
  let result = <></>;

  const iconProps = { iconName: "DateTime" };

  switch (props.nomination.status) {
    case 0:
          result = (
          <>
          {moment.utc(props.nomination.eta).local().format("ll HH:mm")}
          </>
      );
      break;
    case 1:
          result = (
          <>
          {moment
            .utc(props.nomination.arrivalDate)
            .local()
            .format("ll HH:mm")}
          </>
      );
      break;
    case 2:
          result = (
          <>
          {moment
            .utc(props.nomination.departureDate)
            .local()
            .format("ll HH:mm")}
          </>
      );
      break;
    case 4:
          result = (
          <>{moment
            .utc(props.nomination.rejectedDate)
            .local()
            .format("ll HH:mm")}
          </>
      );
      break;
    case 5:
          result = (
          <>{moment
            .utc(props.nomination.haltedDate)
            .local()
            .format("ll HH:mm")}
          </>
      );
      break;
    case 6:
          result = (
          <>{moment
            .utc(props.nomination.repairDate)
            .local()
            .format("ll HH:mm")}
          </>
      );
      break;
    default:
          result = (
          <>{moment
            .utc(props.nomination.arrivalDate)
            .local()
            .format("ll HH:mm")}
          </>
      );
      break;
  }

  return (
    <Fragment>
      {showModal && (
        <EtaModal
          {...props}
          onSuccess={(value: string) => {
            props.onSuccess(value);
            setShowModal(false);
          }}
          onClose={() => setShowModal(false)}
        />
      )}

      {result}
    </Fragment>
  );
};

export default EtaButton;
